import React, { Component } from "react";
import "./HomeTourModal.css";
import {injectIntl} from "react-intl";
import GirlTour from "../../../assets/images/girl_tour.png";
import ExploreStep2Img from "../../../assets/images/explore-step2-img.png";

export class ExploreStep2 extends Component {

    render(){

        return (
            <React.Fragment>
                <div className="e-t-container step2">
                    <div className="e-t-imgcont step2">
                        <img src={GirlTour} alt="girl" className="e-t-img-girl-step2"/>
                    </div>
                    <div className="e-t-texts step2">
                        <img src={ExploreStep2Img} alt="girl" className="e-t-img-step2"/>
                        <p className="e-t-subtitle step2">
                            Esta sección es importante:<br/>Aquí puedes subir tus <span className="e-t-span-color">Assets.</span>
                        </p>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default injectIntl(ExploreStep2);
